// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAJnH5kXITqDLSjXn9CT8-g2DfXVpuu6RQ",

  authDomain: "fundflow0x.firebaseapp.com",

  projectId: "fundflow0x",

  storageBucket: "fundflow0x.appspot.com",

  messagingSenderId: "369324167078",

  appId: "1:369324167078:web:7d5483135e4c253bc4c967",

  measurementId: "G-2C01QJ41BF",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
